export default __webpack_public_path__ + "static/media/fireFN21.b3c0d7da.svg";